import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Printer, Package, ArrowRight } from 'lucide-react';

const LabStore = () => {
  const navigate = useNavigate();

  const sections = [
    {
      id: '3d-printer',
      title: '3D Printer Usage',
      description: 'Track and manage 3D printer reservations, usage logs, and printing queue',
      icon: Printer,
      path: '/lab-store/3d-printer',
      color: 'white',
      bgColor: 'bg-white/5',
      hoverBgColor: 'hover:bg-white/10'
    },
    {
      id: 'inventory',
      title: 'Lab Inventory',
      description: 'Manage lab equipment, chemicals, consumables, and stock levels',
      icon: Package,
      path: '/lab-store/inventory',
      color: 'white',
      bgColor: 'bg-white/5',
      hoverBgColor: 'hover:bg-white/10'
    }
  ];

  return (
    <div className="h-full w-full overflow-y-auto custom-scrollbar relative overflow-hidden">
      {/* Coming Soon Overlay */}
      <div className="coming-soon-overlay">
        <div className="coming-soon-text">Coming Soon</div>
      </div>
      <div className="max-w-7xl mx-auto p-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Lab Store</h1>
          <p className="text-gray-400">Manage lab resources, equipment, and 3D printing services</p>
        </div>

        {/* Section Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <div
                key={section.id}
                onClick={() => navigate(section.path)}
                className={`glass-card p-8 cursor-pointer transition-all duration-300 ${section.hoverBgColor} hover:scale-[1.02] group`}
              >
                <div className={`inline-flex p-4 rounded-2xl ${section.bgColor} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent size={32} className="text-white" style={{ filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.1))' }} />
                </div>
                
                <h2 className="text-2xl font-bold text-white mb-3 flex items-center justify-between">
                  {section.title}
                  <ArrowRight size={24} className="text-gray-500 group-hover:text-white group-hover:translate-x-2 transition-all duration-300" />
                </h2>
                
                <p className="text-gray-400 leading-relaxed">
                  {section.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LabStore;
